import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import SummaryViewEntryListItem from "./SummaryViewEntryListItem";
import { memo } from "react";
import NoEntries from "./NoEntries";
import RenderIfVisible from "../../Utils/RenderIfVisible";

const useStyles = makeStyles((theme) => ({
    summaryGridItem: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1),
        },
    },
}));

export default memo(function SummaryViewEntryList({ linkComponent, entriesData }) {
    const classes = useStyles();

    return (
        <>
            <Grid container justifyContent="center">
                {entriesData && entriesData.length > 0
                    ? (entriesData.map((entryData) => (
                        <Grid id={`e${entryData.entry.id}`} key={`${entryData.entry.id}-${entryData.category?.id}`} item xs={12} lg={6} className={classes.summaryGridItem}>
                            <RenderIfVisible estimatedHeight="300px">
                                <SummaryViewEntryListItem
                                    entry={entryData.entry}
                                    categoryId={entryData.category?.id}
                                    categoryName={entryData.category?.title}
                                    linkComponent={linkComponent}
                                />
                            </RenderIfVisible>
                        </Grid>
                    ))):(
                        <NoEntries />
                    )
                }
            </Grid>
        </>
    );
});